import React, { useEffect, useState } from "react";
import ClientLayout from "../../components/client/ClientLayout";
import RequireClientAdmin from "../../components/client/RequireClientAdmin";
import AcquisitionDashboard from "../../components/AcquisitionDashboard";
import { clientApi } from "../../api";
import { getToken } from "../../utils/authStorage";

const ymd = (d) => d.toISOString().slice(0, 10);
function defaultRange() {
  const to = new Date();
  const from = new Date();
  from.setDate(from.getDate() - 90);
  return { from: ymd(from), to: ymd(to), granularity: "day" };
}

export default function AcquisitionReport() {
  return (
    <ClientLayout>
      <RequireClientAdmin>
        <Inner />
      </RequireClientAdmin>
    </ClientLayout>
  );
}

function Inner() {
  const [filters, setFilters] = useState(defaultRange);
  const [drill, setDrill] = useState({});
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [members, setMembers] = useState([]);
  const [membersTotal, setMembersTotal] = useState(0);
  const [membersLoading, setMembersLoading] = useState(true);

  // Summary (charts + headline numbers) — refetched on filter changes.
  useEffect(() => {
    let alive = true; setLoading(true); setError("");
    clientApi.getAcquisition({ from: filters.from, to: filters.to, granularity: filters.granularity })
      .then((d) => { if (alive) setSummary(d); })
      .catch((e) => { if (alive) setError(e.message); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [filters]);

  // Detail table — refetched on filters OR drill-down.
  useEffect(() => {
    let alive = true; setMembersLoading(true);
    clientApi.getAcquisitionMembers({
      from: filters.from, to: filters.to,
      source: drill.source, medium: drill.medium, campaign: drill.campaign, limit: 500,
    })
      .then((d) => { if (alive) { setMembers(d.rows || []); setMembersTotal(d.total || 0); } })
      .catch(() => { if (alive) { setMembers([]); setMembersTotal(0); } })
      .finally(() => { if (alive) setMembersLoading(false); });
    return () => { alive = false; };
  }, [filters, drill]);

  async function onExport() {
    const token = getToken("client");
    const url = clientApi.signupsCsvUrl({
      from: filters.from, to: filters.to,
      source: drill.source, medium: drill.medium, campaign: drill.campaign,
    });
    const res = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
    if (!res.ok) { setError("Export failed. Please try again."); return; }
    const blob = await res.blob();
    const u = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = u; a.download = "signups-attribution.csv"; a.click();
    URL.revokeObjectURL(u);
  }

  return (
    <AcquisitionDashboard
      summary={summary} loading={loading} error={error}
      members={members} membersTotal={membersTotal} membersLoading={membersLoading}
      filters={filters} setFilters={setFilters}
      drill={drill} setDrill={setDrill}
      onExport={onExport}
    />
  );
}
